window.addEventListener('DOMContentLoaded', function() {
  if (window.location.href.includes('/best-sales') || window.location.href.includes('/dev-')) {
    const crazyRocketIcon = document.querySelector('.crazyrocket-launch-icon');
    if (crazyRocketIcon) {
      crazyRocketIcon.style.display = 'none';
    }
  }

  $('.bs-sku-select').each(function() {
    // 初始化sku选择器
    $(this).select2({
      placeholder: $(this).data('placeholder'),
      allowClear: false
    })

    // 初始化礼物图片
    const parentImgWrapper = $(this).closest('.cla-pcard-item').find('.product-img');
    let giftImg = 'https://cdn.shopify.com/s/files/1/0538/9533/2027/files/2026-love--surprise-bag.png?v=1769841917'
    if (window.location.href.includes('/de-de/')) {
      giftImg = 'https://cdn.shopify.com/s/files/1/0538/9533/2027/files/2026-love--surprise-bag-de.png?v=1769841917'
    }
    if (parentImgWrapper.length > 0) {
      parentImgWrapper.addClass('relative');
      parentImgWrapper.append(`<img src="${giftImg}" alt="gift-img" style="position: absolute; right: 0; bottom: 0;max-width: 128px; width: 25%; padding: 0; padding-right: 20px; padding-bottom: 20px;">`);
    }

      
    // 添加默认选择的sku
    const btnCart = $(this).closest('.cla-pcard-item').find('.bs-love--btn-cart');
    const selectEL = $(this).closest('.cla-pcard-item').find('select');

    var $card = $(this).closest('.cla-pcard-item');
    var fixedVid = $card.attr('data-fixed-variant-id');
    var defaultSkuId;
    if (fixedVid) {
      defaultSkuId = fixedVid;
    } else if (selectEL.length > 0) {
      defaultSkuId = selectEL.val();
    }
    if (btnCart.length > 0) {
      btnCart.attr('items', JSON.stringify({items: [{ id: defaultSkuId, quantity: 1 }]}));
    }
  });
});

function skuSelectChange(target) {
  console.log('skuSelectChange', target, target.value);

  // 找到父盒子 .cla-pcard 下的 btn-cart 元素
  const btnCart = $(target).closest('.cla-pcard-item').find('.bs-love--btn-cart');
  const variantsItemsDom = $(target).closest('.cla-pcard-item').find('.pcard-price-item-wrapper').find('.pcard-price-item');

  // 找到对应的sku-id显示隐藏
  if (variantsItemsDom.length > 0) {
    variantsItemsDom.each(function() {
      if ($(this).data('sku-id') == target.value) {
        $(this).addClass('active');
      } else {
        $(this).removeClass('active');
      }
    });
  }

  // 更新要添加到cart的sku信息
  var $card = $(target).closest('.cla-pcard-item');
  var fixedVid = $card.attr('data-fixed-variant-id');
  var resolvedId = fixedVid || target.value;
  if (btnCart.length > 0) {
    btnCart.attr('items', JSON.stringify({items: [{ id: resolvedId, quantity: 1 }]}));
  }
}